import { render, staticRenderFns } from "./Floating.vue?vue&type=template&id=2b7f5cc9&scoped=true"
import script from "./Floating.vue?vue&type=script&lang=js"
export * from "./Floating.vue?vue&type=script&lang=js"
import style0 from "./Floating.vue?vue&type=style&index=0&id=2b7f5cc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f5cc9",
  null
  
)

export default component.exports